export const QA_NAME_APPOINTMENT_FORM_MODAL = 'appointmentFormModal'

export const QA_NAME_APPOINTMENT_FORM_SUBMIT = 'appointmentFormSubmit'

export const APPOINTMENT_FORM_FIELD_NAME = {
  building: 'building',
  description: 'description',
  end: 'end_at',
  firstDay: 'first_day',
  flat: 'flat',
  isAllDay: 'is_all_day',
  lastDay: 'last_day',
  location: 'location',
  participants: 'participants',
  reminder: 'reminder_offset_minutes',
  request: 'request',
  start: 'start_at',
  title: 'title',
  type: 'appointment_type',
}

export const APPOINTMENT_FORM_TITLE_MAX_LENGTH = 255

export const APPOINTMENT_FORM_LOCATION_MAX_LENGTH = 255

export const APPOINTMENT_FORM_DESCRIPTION_MIN_ROWS = 3

export const APPOINTMENT_FORM_DEFAULT_DURATION_MINUTES = 60

export const APPOINTMENT_FORM_SPAN_ERROR_KEY =
  'Appointment.FormEndBeforeStartKey'
